import { required, maxLength } from 'vuelidate/lib/validators'

const regexCodigo = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return (
    /^[0-9]{1,2}$/g.test(value) || (/^\d{1,2}(.{1}\d{2,}){1,}/g.test(value) && /\d.?/.test(value) && /\d{2,}$/g.test(value))
  )
}

export const validateData = {
  form: {
    description: { required, maxLength: maxLength(30) },
    codigo: { required, regexCodigo },
  },
}

export const validateComputed = {
  descriptionErrors() {
    const errors = []
    if (!this.$v.form.description.$dirty) return errors
    !this.$v.form.description.required && errors.push('Descrição é obrigatória.')
    !this.$v.form.description.maxLength && errors.push('Descrição não pode conter mais de 30 caracteres.')
    return errors
  },
  codigoErrors() {
    const errors = []
    if (!this.$v.form.codigo.$dirty) return errors
    !this.$v.form.codigo.required && errors.push('Código é obrigatório.')
    !this.$v.form.codigo.regexCodigo && errors.push('Código deve ter apenas números e pontos.')
    return errors
  },
}
